import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import BackButton from '../../../lib/components/BackButton';
import { headerWrapper } from './styles';
const Header = ({ goBackButton, goBackHandler, title, subtitle }) => {
    return (_jsxs(Box, { sx: headerWrapper, children: [goBackButton && _jsx(BackButton, { onClick: goBackHandler }), _jsx(Typography, { variant: 'h1', children: title }), subtitle && (_jsx(Typography, { className: 'subtitle', variant: 'subtitle1', children: subtitle }))] }));
};
export default Header;
